import { render, staticRenderFns } from "./border-comp3.vue?vue&type=template&id=b802d82c"
import script from "./border-comp3.vue?vue&type=script&lang=js"
export * from "./border-comp3.vue?vue&type=script&lang=js"
import style0 from "./border-comp3.vue?vue&type=style&index=0&id=b802d82c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports